import { SidebarLink } from 'types/sidebar'

import {
  PAGE_AGGREGATOR_API_LOG,
  PAGE_AGGREGATOR_MANAGEMENT,
  PAGE_CONFIG,
  PAGE_ERP_API_LOGS,
  PAGE_FTP_PROFILE,
  PAGE_FTP_CREATION_LOGS,
  PAGE_FUNC_JOBS,
  PAGE_IMPORT_LOGS,
  PAGE_INVENTORY,
  PAGE_MASTER_DATA,
  PAGE_BUNDLE_PRODUCT,
  PAGE_PRICING,
  // PAGE_STORE_ORDERS,
  PAGE_ADMIN_ORDERS,
  PAGE_POS_API_LOGS,
  PAGE_SMART_OOS,
  PAGE_STORE_MGMT,
  PAGE_USER_MGMT,
  PAGE_EXPORT_LOGS,
  PAGE_ORDERS_LOGS,
  PAGE_RECONCILIATION_LOGS,
  PAGE_AREAS_MAPPING_MANAGEMENT,
  PAGE_POS_AREAS_MAPPING_MANAGEMENT,
  PAGE_PICKER_EMP_MAP,
  PAGE_POS_CONFIG,
  COST_MANAGEMENT,
  PAGE_TALON_LOGS,
  PAGE_SAP_LOGS,
  PAGE_ECOM_PRICING_DATA,
  PAGE_DELIVEROO_SYNC_LOGS,
  PAGE_CATALOGUE_ACTION_LOGS,
  PAGE_INVENTORY_STOCK_CHECKER,
  PAGE_FOC_ORDER_LIST,
  PAGE_CHAIN_MGMT,
  PAGE_CLONE_INVENTORY_PRICE,
  PAGE_TALABAT_LOGS,
  PAGE_PRICE_LABEL,
  PAGE_PRICE_LABEL_SYNC_HISTORY,
  PAGE_PRICE_LABEL_REPORT,
  PAGE_NEW_SAP_BARCODE,
  PAGE_STOCK_OUT_REPORT,
  PAGE_POS_OPEN_ORDERS,
  PAGE_ADMIN_AUDIT_LOGS,
  PAGE_TIME_STAMP_RESET,
  PAGE_PENDING_ERP_SYNC_ORDER,
  PAGE_PENDING_ERP_SYNC_RMA,
  PAGE_PENDING_ERP_SYNC_RECON,
  PAGE_POWER_BI_SYNC_LOGS,
  PAGE_KDS_SYNC_LOGS,
  PAGE_LAST_MILE_LOGS,
  PAGE_GENERIC_LOGS,
  PAGE_PURCHASE_TIMER,
  PAGE_FRESH_CATEGORY,
  PAGE_FRESH_MANDATORY_BARCODE,
  PAGE_FRESH_REPORTS,
  PAGE_CRON_JOBS,
} from './pages'

import {
  BagIcon,
  AggregatorIcon,
  FtpConfigurationIcon,
  DashboardIcon,
  LogIcon,
  SmartOosIcon,
  SettingsIcon,
  StoreIcon,
  UserIcon,
  LocationIcon,
  CostIcon,
  PosLocation,
  InventoryIcon,
  ChainIcon,
  TimeIcon,
} from 'components/icons'

export const SIDEBAR_LINKS: SidebarLink[] = [
  // { ...PAGE_STORE_ORDERS, icon: BagIcon },
  {
    id: 'DASHBOARD',
    name: 'Dashboard',
    icon: DashboardIcon,
    children: [
      PAGE_MASTER_DATA,
      PAGE_BUNDLE_PRODUCT,
      PAGE_INVENTORY,
      PAGE_STOCK_OUT_REPORT,
      PAGE_PRICING,
      PAGE_ADMIN_ORDERS,
      PAGE_ECOM_PRICING_DATA,
      PAGE_PRICE_LABEL,
      PAGE_PRICE_LABEL_SYNC_HISTORY,
      PAGE_PRICE_LABEL_REPORT,
      PAGE_NEW_SAP_BARCODE,
      PAGE_POS_OPEN_ORDERS,
      PAGE_PURCHASE_TIMER,
    ],
  },
  {
    id: 'PENDING ERP SYNC',
    name: 'Failed ERP Sync',
    icon: DashboardIcon,
    children: [
      PAGE_PENDING_ERP_SYNC_ORDER,
      PAGE_PENDING_ERP_SYNC_RMA,
      PAGE_PENDING_ERP_SYNC_RECON,
    ],
  },
  {
    ...PAGE_SMART_OOS,
    icon: SmartOosIcon,
  },
  {
    ...PAGE_FUNC_JOBS,
    icon: BagIcon,
  },
  {
    ...PAGE_CRON_JOBS,
    icon: TimeIcon,
  },
  {
    id: 'LOGS',
    name: 'Logs',
    icon: LogIcon,
    children: [
      PAGE_ERP_API_LOGS,
      PAGE_POS_API_LOGS,
      PAGE_FTP_CREATION_LOGS,
      PAGE_AGGREGATOR_API_LOG,
      PAGE_IMPORT_LOGS,
      PAGE_EXPORT_LOGS,
      PAGE_ORDERS_LOGS,
      PAGE_RECONCILIATION_LOGS,
      PAGE_TALON_LOGS,
      PAGE_SAP_LOGS,
      PAGE_DELIVEROO_SYNC_LOGS,
      PAGE_TALABAT_LOGS,
      PAGE_CATALOGUE_ACTION_LOGS,
      PAGE_POWER_BI_SYNC_LOGS,
      PAGE_KDS_SYNC_LOGS,
      PAGE_LAST_MILE_LOGS,
      PAGE_ADMIN_AUDIT_LOGS,
      PAGE_GENERIC_LOGS,
    ],
  },
  {
    ...PAGE_CONFIG,
    icon: SettingsIcon,
  },
  {
    ...PAGE_POS_CONFIG,
    icon: SettingsIcon,
  },
  {
    ...PAGE_USER_MGMT,
    icon: UserIcon,
  },
  {
    ...PAGE_STORE_MGMT,
    icon: StoreIcon,
  },
  {
    ...PAGE_AGGREGATOR_MANAGEMENT,
    icon: AggregatorIcon,
  },
  {
    ...PAGE_FTP_PROFILE,
    icon: FtpConfigurationIcon,
  },
  {
    ...PAGE_AREAS_MAPPING_MANAGEMENT,
    icon: LocationIcon,
  },
  {
    ...PAGE_POS_AREAS_MAPPING_MANAGEMENT,
    icon: PosLocation,
  },
  {
    ...PAGE_PICKER_EMP_MAP,
    icon: UserIcon,
  },
  {
    ...COST_MANAGEMENT,
    icon: CostIcon,
  },
  {
    ...PAGE_INVENTORY_STOCK_CHECKER,
    icon: InventoryIcon,
  },
  {
    ...PAGE_CLONE_INVENTORY_PRICE,
    icon: InventoryIcon,
  },
  {
    ...PAGE_FOC_ORDER_LIST,
    icon: CostIcon,
  },
  {
    ...PAGE_CHAIN_MGMT,
    icon: ChainIcon,
  },

  {
    ...PAGE_TIME_STAMP_RESET,
    icon: TimeIcon,
  },
  {
    id: 'FRESH INVENTORY',
    name: 'Fresh Inventory',
    icon: InventoryIcon,
    children: [
      PAGE_FRESH_CATEGORY,
      PAGE_FRESH_MANDATORY_BARCODE,
      PAGE_FRESH_REPORTS,
    ],
  },
]
